
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelancerInformationResource,
} from '../models';
import {
    FreelancerInformationResourceFromJSON,
    FreelancerInformationResourceToJSON,
} from '../models';

/**
 * 
 */
export class FreelancerInformationApi extends runtime.BaseAPI {

    /**
          */
    async informationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerInformationResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerInformationResource>({
            path: `/project-freelancer/api/information`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async information(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerInformationResource> {
        const response = await this.informationRaw(initOverrides);
        return response._data;
    }

}
